export default{
    init(){
        this.openSelect();
        this.selectWorker();
    },
    openSelect(){
        $('body').off('click','.bb-workers-select .selected-workers')
        .on('click','.bb-workers-select .selected-workers', function(e) {
           const parentContainer = $(this).parent();
           $(parentContainer).toggleClass('opened');
           let posY = $(parentContainer).height() + 8;
           $(parentContainer).find('.workers-list').css({top: posY});
        });
    },
    selectWorker(){
        $('body').off('click', '.bb-workers-select .worker-row')
        .on('click', '.bb-workers-select .worker-row', (e) => {
            const input = $(e.currentTarget).find('input');

            if ($(input).is(':checked')) {
                $(input).removeAttr('checked');
            } else {
                $(input).attr('checked', 'checked');
            }
            this.actualizeSelectedWorkers();
        })
    },
    actualizeSelectedWorkers(){
        let inputs = $('.bb-workers-select .workers-list').find('input:checked').toArray();
        let workers_string = '';
        if ($('.bb-workers-select .workers-list').find('#any-worker').is(':checked')) {
            workers_string = 'Any Worker';
        } else {
            inputs.forEach(element => {
                if (workers_string == '') {
                    workers_string +=$(element).val();
                } else {
                    workers_string += ', '+$(element).val();
                }
            });
        }
        $('.bb-workers-select .selected-workers').text(workers_string);
        let posY = $('.bb-workers-select').height() + 8;
        $('.bb-workers-select').find('.workers-list').css({top: posY});
    }
}
